import { Injectable } from '@angular/core';
import { config } from '../helper/config'
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class ForgotpasswordService {

  constructor(private http:HttpClient) { }

  forgotpassword(data):Observable<any>{
    return this.http.post(config.api + 'auth/forgotPassword',data);
  }
}
